module.exports = __webpack_public_path__ + "static/bible-verse-66f1b108fb4c6639e289d645a3e50974.jpg";